import { call, put, takeLatest, all, cancelled } from "redux-saga/effects"
import { push } from "connected-react-router"
import axios from "axios"
import { ROLE_LEADER } from "utils/constants"
import { GET_QUALITATIVE_ANSWERS_WATCHER } from "./constants"

import {
  getQualitativeAnswersSuccess,
  getQualitativeAnswersWordCloudSuccess,
} from "./actions"
import { LOCAL_TOKEN } from "../../../utils/storage"

function getWordCloudApi(params) {
  let url = `reports/measure/${params.measure}/answers/wordcloud`
  const isLeadershipMedition = params.measure_type === 2
  return axios.request({
    method: "GET",
    cancelToken: params.token,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    params: {
      "filter[question]": params.question,
      "filter[leader]": isLeadershipMedition ? params.division : null,
      "filter[type]": params.type,
      ...params.params,
    },
    url: `${process.env.API_URL + url}`,
  })
}

function getQualitativeApi(params) {
  let url = `reports/measure/${params.measure}/answers`
  const isLeadershipMedition = params.measure_type === 2
  return axios.request({
    method: "GET",
    cancelToken: params.token,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    params: {
      "filter[question]": params.question,
      "filter[leader]": isLeadershipMedition ? params.division : null,
      "filter[type]": params.type,
      ...params.params,
    },
    url: `${process.env.API_URL + url}`,
  })
}

export function* getAnswersSaga(params) {
  const cancelSource = axios.CancelToken.source()
  try {
    params.payload.token = cancelSource.token
    const [answersApi, wordCloud] = yield all([
      call(getQualitativeApi, params.payload),
      call(getWordCloudApi, params.payload),
    ])
    let result = answersApi.data
    let resultWordCloud = wordCloud.data.data
    yield put(getQualitativeAnswersSuccess(result))
    yield put(getQualitativeAnswersWordCloudSuccess(resultWordCloud))
  } catch (e) {
    const result = e
    switch (result.response.status) {
      case 404:
        yield put(push("/error"))
        break
    }
  } finally {
    if (yield cancelled()) {
      cancelSource.cancel()
    }
  }
}

// Individual exports for testing
export default function* reportsPageSaga() {
  yield takeLatest(GET_QUALITATIVE_ANSWERS_WATCHER, getAnswersSaga)
  // See example in containers/HomePage/saga.js
}
